import React										from 'react';

import {useAppSelector}								from '../../../app/hooks';
import {AllContract}								from '../../../redux/contracts/interface';

import {ft_getContractStatus}						from '../../functions/contractFunction';

import LANGUAGE										from '../../language';

import './ContractComponent.css';

interface ContractStatusProps {
	contract: AllContract | undefined,
	indexFunder?: number
}

function ContractStatus(props: ContractStatusProps) {
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	if (!props.contract)
		return <></>;

	const finalStatus = ft_getContractStatus(props.contract, props.indexFunder);

	return (
		<span className={`deviceStatus ${finalStatus}`}>{TEXTE.contract.contractStatus[finalStatus]}</span>
	);
}

export default ContractStatus;
